export enum EuRegistrationStatusInternal {

   pending,
   in_processing,
   processed,
   unfinished_reminder,
   unfinished_closed,
}